const ALLOWED_PROTOCOLS = new Set(["http:", "https:", "mailto:", "tel:", "sms:"]);

/**
 * Is `value` a link the widget may hand to `window.open` on an operator's behalf (a quick-action
 * `open-url`)? Only absolute http(s) / mailto / tel / sms: a `javascript:` or `data:` URL would run
 * in the widget's own origin, which holds every embed's visitor session.
 */
export function isSafeExternalUrl(value: unknown): value is string {
  if (typeof value !== "string") return false;
  try {
    // No base: a relative or protocol-relative value throws, and is rejected.
    return ALLOWED_PROTOCOLS.has(new URL(value.trim()).protocol);
  } catch {
    return false;
  }
}
